<template>

<div class="mbh-notes" v-if="data">

	<div class="mbh-intro" v-if="data.intro" v-html="data.intro"></div>

	<textarea class="mbh-notes-textarea" v-model="notes" :placeholder="data.placeholder || 'Use this section to jot down any thoughts you have or questions that you would like to ask your healthcare professional...'"></textarea>

	<div class="mbh-notes-foot">
		<button class="mbh-save-button" :class="{'is-disabled': !notes.length}" v-on:click="notes.length && onSave()">Save</button>
	</div>

</div>

</template>

<script>

export default {

	props: ['data'],

	data: function() {

		return {
			notes: ''
		}

	},

	created: function() {

		this.notes = localStorage.getItem('ifrap_patient_notes') || ''
		if (this.notes.length) this.$emit('complete')

	},

	methods: {

		onSave: function() {

			localStorage.setItem('ifrap_patient_notes', this.notes)
			if (this.notes.length) this.$emit('complete')
			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.mbh-intro { font-size: 18px; color: #343434; line-height: 28px; margin-bottom: 24px; font-weight: 300; }

.mbh-notes-textarea {
	width: 100%; min-height: 250px; padding: 24px; font-size: 16px; line-height: 26px;
	color: #343434; border: 2px solid #e0e0e0; border-radius: 16px; resize: vertical;
	outline: none; font-family: inherit; margin-bottom: 16px; background-color: #fff;
}

.mbh-notes-textarea:focus { border-color: var(--aid-color); }
.mbh-notes-foot { display: flex; justify-content: center; }

</style>
